(function () {
  if (window.__ksLoaded) return;
  window.__ksLoaded = true;
  // Bundle selector: writes the chosen variant into Dawn's product form
  function initBundles(root) {
    root.querySelectorAll('[data-ks-bundles]').forEach(function (box) {
      var form = document.getElementById(box.dataset.formId);
      var cards = box.querySelectorAll('.ks-bundle');
      function select(card) {
        cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
        var input = card.querySelector('input');
        input.checked = true;
        if (!form) return;
        var idField = form.querySelector('input[name="id"]');
        if (idField) { idField.value = input.value; idField.disabled = false; }
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = input.dataset.available !== 'true';
        document.querySelectorAll('[data-ks-sticky-price]').forEach(function (el) { el.textContent = input.dataset.price; });
      }
      cards.forEach(function (card) {
        card.addEventListener('change', function () { select(card); });
      });
      var initial = box.querySelector('.ks-bundle.is-selected') || cards[0];
      if (initial) select(initial);
    });
  }

  // Delivery estimate: skips weekends
  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) n--; }
    return d;
  }
  function initDelivery(root) {
    root.querySelectorAll('[data-ks-delivery]').forEach(function (el) {
      var min = +el.dataset.min, max = +el.dataset.max, cutoff = +el.dataset.cutoff;
      var now = new Date();
      var start = now;
      if (now.getHours() >= cutoff || now.getDay() % 6 === 0) start = addBusinessDays(now, 1);
      var fmt = { weekday: 'short', month: 'short', day: 'numeric' };
      var a = addBusinessDays(start, min).toLocaleDateString('en-US', fmt);
      var b = addBusinessDays(start, max).toLocaleDateString('en-US', fmt);
      var out = el.querySelector('[data-ks-dates]');
      if (out) out.textContent = min === max ? a : a + ' – ' + b;
    });
  }

  // Sticky add to cart: on phones it shows whenever the main buy button is off screen
  // (so it's there on the first screen); on desktop only after the button scrolls past
  function initSticky() {
    var bar = document.querySelector('[data-ks-sticky]');
    var mainBtn = document.querySelector('product-form form[data-type="add-to-cart-form"] [type="submit"]');
    if (!bar || !mainBtn) return;
    var phone = window.matchMedia('(max-width: 749px)');
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && (phone.matches || e.boundingClientRect.top < 0));
    }).observe(mainBtn);
    bar.querySelector('[data-ks-sticky-btn]').addEventListener('click', function () { mainBtn.click(); });
  }

  // Countdown to midnight (resets daily; honest "today's offer" timer)
  function initCountdown() {
    document.querySelectorAll('[data-ks-countdown]').forEach(function (el) {
      function tick() {
        var now = new Date(), end = new Date(now);
        end.setHours(24, 0, 0, 0);
        var s = Math.floor((end - now) / 1000);
        var h = String(Math.floor(s / 3600)).padStart(2, '0');
        var m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
        var sec = String(s % 60).padStart(2, '0');
        el.textContent = h + ':' + m + ':' + sec;
      }
      tick(); setInterval(tick, 1000);
    });
  }

  // "(694 Reviews)" link under the title scrolls to the reviews section
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ks-to-reviews]');
    if (!a) return;
    var t = document.querySelector('.ks-reviews');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function init(root) { initBundles(root); initDelivery(root); }
  document.addEventListener('DOMContentLoaded', function () { init(document); initSticky(); initCountdown(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

// Mobile gallery dots (Stepprs-style) under the main product slider
(function () {
  function build() {
    var mq = window.matchMedia('(max-width: 749px)');
    document.querySelectorAll('[id^="GalleryViewer-"]').forEach(function (viewer) {
      if (viewer.dataset.ksDots) return;
      var list = viewer.querySelector('.product__media-list');
      if (!list) return;
      var slides = [].slice.call(list.querySelectorAll('.product__media-item'));
      if (slides.length < 2) return;
      viewer.dataset.ksDots = '1';
      var dots = document.createElement('div');
      dots.className = 'ks-gdots';
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Image ' + (i + 1));
        b.addEventListener('click', function () { list.scrollTo({ left: s.offsetLeft - list.offsetLeft, behavior: 'smooth' }); });
        dots.appendChild(b);
      });
      viewer.after(dots);
      function update() {
        var w = list.clientWidth || 1, i = Math.round(list.scrollLeft / (slides[0].getBoundingClientRect().width || w));
        [].forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      list.addEventListener('scroll', update, { passive: true }); update();
    });
  }
  if (document.readyState !== 'loading') build(); else document.addEventListener('DOMContentLoaded', build);
})();
